import '../styles/AboutUs.css';

const facts = [
    { label: "Founded", value: "2022" },
    { label: "Registered in", value: "South Africa" },
    { label: "Specialising in", value: "Medical device licensing & compliance" },
    { label: "Supporting", value: "Entrepreneurs, distributors & healthcare providers" },
];

const AboutUs = () => {
    return (
        <section className="km-section AboutUsContainer" id="about">
            <div className="km-container about-grid">
                <div data-reveal>
                    <p className="km-eyebrow">About us</p>
                    <h2 className="km-title">About KOLE MEDICAL</h2>
                    <p className="km-lead">
                        Founded in 2022, KOLE MEDICAL (PTY) LTD is a South African registered healthcare
                        consultancy specializing in comprehensive medical device business advising.
                    </p>
                    <p className="about-body">
                        The consultancy supports distributors, private healthcare providers, entrepreneurs and
                        emerging medical device manufacturers by offering operational, marketing, regulatory and
                        strategic guidance across the entire medical device value chain.
                    </p>
                </div>
                <dl className="about-facts" data-reveal style={{ "--reveal-order": 1 } as React.CSSProperties}>
                    {facts.map((fact) => (
                        <div className="about-fact" key={fact.label}>
                            <dt>{fact.label}</dt>
                            <dd>{fact.value}</dd>
                        </div>
                    ))}
                </dl>
            </div>
        </section>
    );
};

export default AboutUs;
